import {
  FaUserGraduate,
  FaSearch,
  FaCalculator,
  FaAward,
} from "react-icons/fa";
import {
  MdPayments,
  MdAccountBalanceWallet,
  MdCompare,
  MdOutlineDomainVerification,
} from "react-icons/md";
import { BsFillPersonFill } from "react-icons/bs";
import { GiBrain } from "react-icons/gi";
import React from "react";

const ExperienceCard = [
  {
    id: 1,
    category: "education",
    // icon: "icon-graduation",
    icon: <FaUserGraduate />,
    year: "2007 - 2011",
    title: "Explore Exciting Domain Opportunities",
    description:
      "Explore premium domains tailored to your needs for a perfect online identity. ",
  },
  {
    id: 2,
    category: "education",
    // icon: "icon-graduation",
    icon: <FaSearch />,
    year: "2016 - 2018",
    title: "In-Depth Domain Analysis",
    description:
      "Gain insights on domain history, traffic, and SEO metrics for informed decisions.",
  },
  {
    id: 3,
    category: "education",
    // icon: "icon-graduation",
    icon: <FaCalculator />,
    year: "2022 - 2022",
    title: "Seamlessly Place Bids",
    description:
      "Place competitive bids seamlessly with a fair and transparent system.",
  },
  {
    id: 4,
    category: "education",
    // icon: "icon-graduation",
    icon: <MdPayments />,
    year: "2022 - 2022",
    title: "Secure Your Domain",
    description:
      "Secure your digital asset with a streamlined transfer process backed by our support team.",
  },
  {
    id: 4,
    category: "work",
    // icon: "icon-briefcase",
    icon: <BsFillPersonFill />,
    year: "2009 - 2015",
    title: "List Your Domain",
    description:
      "List your domain for sale, showcase its potential, set a reserve price.",
  },
  {
    id: 5,
    category: "work",
    // icon: "icon-briefcase",
    icon: <MdAccountBalanceWallet />,
    year: "2012 - 2015",
    title: "Domain Valuation & Appraisal",
    description:
      "Obtain a fair valuation and set the right price to attract serious buyers.",
  },
  {
    id: 6,
    category: "work",
    // icon: "icon-briefcase",
    icon: <MdCompare />,
    year: "2018 - 2022",
    title: "Reach a Targeted Audience",
    description:
      "Maximize exposure by targeting specific industries and leveraging promotions.",
  },
  {
    id: 7,
    category: "work",
    // icon: "icon-briefcase",
    icon: <MdOutlineDomainVerification />,
    year: "2022 - Present",
    title: "Secure Transactions & Transfer",
    description:
      "Secure your transactions with our domain sale agreement templates and streamline transfers.",
  },
];

export default ExperienceCard;

export const Buyers_old = [
  {
    id: 1,
    icon: <FaUserGraduate />,
    title: "Explore Exciting Domain Opportunities",
    description:
      "Explore premium domains tailored to your needs for a perfect online identity. ",
  },
  {
    id: 2,
    icon: <FaSearch />,
    title: "In-Depth Domain Analysis",
    description:
      "Gain insights on domain history, traffic, and SEO metrics for informed decisions.",
  },
  {
    id: 3,
    icon: <FaCalculator />,
    title: "Seamlessly Place Bids",
    description:
      "Place competitive bids seamlessly with a fair and transparent system.",
  },
  {
    id: 4,
    icon: <MdPayments />,
    title: "Secure Your Domain",
    description:
      "Secure your digital asset with a streamlined transfer process backed by our support team.",
  },
];

export const Buyers = [
  {
    id: 1,
    icon: <FaAward />,
    title: "Premium Picks",
    description: "Finest .gold domains, chosen for maximum impact.",
  },
  {
    id: 2,
    icon: <FaSearch />,
    title: "Comprehensive R&A",
    description:
      "We did the research so that you get an exclusive .gold domain.",
  },
  {
    id: 3,
    icon: <GiBrain />,
    title: "Domain Expertise",
    description:
      "Your needs & Our expertise lead to these premium .gold domains",
  },
  // {
  //   id: 4,
  //   icon: <MdPayments />,
  //   title: "Secure Domains",
  //   description: "Streamlined transfer process backed by our support team.",
  // },
];

export const Sellers_old = [
  {
    id: 1,
    icon: <BsFillPersonFill />,
    title: "List Your Domain",
    description:
      "List your domain for sale, showcase its potential, set a reserve price.",
  },
  {
    id: 2,
    icon: <MdAccountBalanceWallet />,
    title: "Domain Valuation & Appraisal",
    description:
      "Obtain a fair valuation and set the right price to attract serious buyers.",
  },
  {
    id: 3,
    icon: <MdCompare />,
    title: "Reach a Targeted Audience",
    description:
      "Maximize exposure by targeting specific industries and leveraging promotions.",
  },
  {
    id: 4,
    icon: <MdOutlineDomainVerification />,
    title: "Secure Transactions & Transfer",
    description:
      "Secure your transactions with our domain sale agreement templates and streamline transfers.",
  },
];

export const Sellers = [
  {
    id: 1,
    icon: <BsFillPersonFill />,
    title: "List Your Domain",
    description: "List, showcase, and set reserve price for your domain.",
  },
  {
    id: 2,
    icon: <MdAccountBalanceWallet />,
    title: "Valuation & Pricing",
    description: "Get a fair valuation to attract serious buyers.",
  },
  {
    id: 3,
    icon: <MdCompare />,
    title: "Targeted Exposure",
    description: "Maximize exposure in specific industries with promotions.",
  },
  {
    id: 4,
    icon: <MdOutlineDomainVerification />,
    title: "Secure Transfers",
    description: "Use our templates for secure transactions and transfers.",
  },
];
